// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.re-usable-modal-terms.ant-modal .ant-modal-content {
  justify-content: space-between;
  padding-top: 20px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  border-bottom-width: 1px;
  border: 1px solid #f3f4f6 !important;
}
.campaign-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 12px;
  padding-left: 16px;
  border-radius: 14px;
  border-width: 2px;
  border: 2px solid #f3f4f6;
  width: 100%;
  margin-top: 5px;
}
.campaign-container:hover {
  border: 2px solid #ffb8b8;
  background: #d2042d12 !important;
}
.campaign-search-list {
  width: 100% !important;
  height: 40px !important;
  border-radius: 14px;
  border-width: 1px;
  border: 1px solid #e5e7eb !important;
  margin-top: 10px;
}
.approve-offer-icon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #dcfce7;

  display: flex;
  align-items: center;
  justify-content: center;
}

.approve-offer-icon .anticon {
  font-size: 20px;
  color: #16a34a;
}
.approve-offer-modal {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
.approve-offer-actions {
  display: flex;
  gap: 12px;
  width: 100%;
}

.approve-offer-actions .ant-btn {
  height: 30px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
}

/* Cancel */

.approve-offer-cancel-button {
  flex: 1 1;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.approve-offer-cancel-button:hover,
.approve-offer-cancel-button:focus {
  border-color: #cbd5e1 !important;
  background: #f8fafc !important;
  color: #334155 !important;
}

.approve-offer-confirm-button {
  flex: 1 1;
  border: 1px solid #16a34a;
  background: #16a34a;
  color: #ffffff;
}

.approve-offer-confirm-button:hover,
.approve-offer-confirm-button:focus {
  border-color: #15803d !important;
  background: #15803d !important;
  color: #ffffff !important;
}
.approve-action-modal {
  width: 25% !important;
}
.approve-offer-details {
  margin-bottom: 20px;
  padding: 12px 16px;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  width: 100%;
  background: #f0fdf4;
}

.approve-offer-detail-row {
  min-height: 26px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.approve-offer-detail-label {
  color: #64748b;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}

.approve-offer-detail-value {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  text-align: right;
  white-space: nowrap;
}

.approve-offer-detail-value.approve-price {
  color: #15803d;
}
.approve-offer-payment-table-row {
  align-items: flex-start;
}

.approve-offer-payment-details {
  flex: 1 1;
  min-width: 0;
}

.approve-offer-table {
  width: 100%;
  overflow: hidden;
  border: none !important;
  border-radius: 12px;
  background: #f0fdf4 !important;
}

.approve-offer-table .ant-table,
.approve-offer-table .ant-table-container,
.approve-offer-table .ant-table-content {
  background: #f0fdf4 !important;
}

.approve-offer-table .ant-table-thead > tr > th {
  padding: 6px 8px !important;
  background: #dcfce7 !important;
  color: #166534 !important;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #bbf7d0 !important;
}

.approve-offer-table .ant-table-tbody > tr > td {
  padding: 6px 8px !important;
  background: #f0fdf4 !important;
  color: #101828 !important;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #bbf7d0 !important;
}

.approve-offer-table .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #f0fdf4 !important;
}

.approve-offer-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

.approve-offer-percentage {
  color: #64748b;
  font-size: 10px;
  font-weight: 400;
}

.approve-offer-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.bulk-campaign-modal-content {
  width: 100%;
}
.bulk-campaign-form .ant-form-item {
  margin-bottom: 16px;
}
.bulk-campaign-form .ant-form-item-label {
  padding-bottom: 6px;
}
.bulk-campaign-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.bulk-campaign-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.bulk-campaign-modal-actions .ant-btn {
  min-width: 120px;
}
.bulk-campaign-modal-actions .common-button-red {
  min-width: 180px;
}
.bulk-campaign-date-picker.ant-picker-outlined {
  background: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #d9d9d9 !important;
}
/* Inactive option text */
.bulk-campaign-radio-group .ant-radio-wrapper {
  color: #99a1af;
}

/* Selected option text */
.bulk-campaign-radio-group .ant-radio-wrapper-checked {
  color: #000000;
}
.select-campaign-dropdown .ant-select-selector {
  padding: 0px !important;
}
.cancel-create-campaign-btn {
  height: 35px !important;
  border-radius: 5px !important;
  background: #f3f4f6 !important;
  border-color: #d9d9d9 !important;
  color: #000000 !important;
  font-family: Roboto !important;
  font-weight: 500;
}
@media (max-width: 576px) {
  .bulk-campaign-form > div:first-child {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 0 !important;
  }

  .bulk-campaign-radio-group {
    flex-direction: column;
    gap: 8px;
  }

  .bulk-campaign-modal-actions {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/re-usable-modal/ReusableModal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,SAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;AACA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE;IACE,gDAAgD;IAChD,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".re-usable-modal-terms.ant-modal .ant-modal-content {\n  justify-content: space-between;\n  padding-top: 20px;\n  padding-right: 24px;\n  padding-bottom: 16px;\n  padding-left: 24px;\n  border-bottom-width: 1px;\n  border: 1px solid #f3f4f6 !important;\n}\n.campaign-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  padding-right: 16px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  border-radius: 14px;\n  border-width: 2px;\n  border: 2px solid #f3f4f6;\n  width: 100%;\n  margin-top: 5px;\n}\n.campaign-container:hover {\n  border: 2px solid #ffb8b8;\n  background: #d2042d12 !important;\n}\n.campaign-search-list {\n  width: 100% !important;\n  height: 40px !important;\n  border-radius: 14px;\n  border-width: 1px;\n  border: 1px solid #e5e7eb !important;\n  margin-top: 10px;\n}\n.approve-offer-icon {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background: #dcfce7;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.approve-offer-icon .anticon {\n  font-size: 20px;\n  color: #16a34a;\n}\n.approve-offer-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n.approve-offer-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n.approve-offer-actions .ant-btn {\n  height: 30px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: none;\n}\n\n/* Cancel */\n\n.approve-offer-cancel-button {\n  flex: 1;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.approve-offer-cancel-button:hover,\n.approve-offer-cancel-button:focus {\n  border-color: #cbd5e1 !important;\n  background: #f8fafc !important;\n  color: #334155 !important;\n}\n\n.approve-offer-confirm-button {\n  flex: 1;\n  border: 1px solid #16a34a;\n  background: #16a34a;\n  color: #ffffff;\n}\n\n.approve-offer-confirm-button:hover,\n.approve-offer-confirm-button:focus {\n  border-color: #15803d !important;\n  background: #15803d !important;\n  color: #ffffff !important;\n}\n.approve-action-modal {\n  width: 25% !important;\n}\n.approve-offer-details {\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  border: 1px solid #bbf7d0;\n  border-radius: 12px;\n  width: 100%;\n  background: #f0fdf4;\n}\n\n.approve-offer-detail-row {\n  min-height: 26px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.approve-offer-detail-label {\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.approve-offer-detail-value {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.approve-offer-detail-value.approve-price {\n  color: #15803d;\n}\n.approve-offer-payment-table-row {\n  align-items: flex-start;\n}\n\n.approve-offer-payment-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.approve-offer-table {\n  width: 100%;\n  overflow: hidden;\n  border: none !important;\n  border-radius: 12px;\n  background: #f0fdf4 !important;\n}\n\n.approve-offer-table .ant-table,\n.approve-offer-table .ant-table-container,\n.approve-offer-table .ant-table-content {\n  background: #f0fdf4 !important;\n}\n\n.approve-offer-table .ant-table-thead > tr > th {\n  padding: 6px 8px !important;\n  background: #dcfce7 !important;\n  color: #166534 !important;\n  font-size: 13px;\n  font-weight: 600;\n  border-bottom: 1px solid #bbf7d0 !important;\n}\n\n.approve-offer-table .ant-table-tbody > tr > td {\n  padding: 6px 8px !important;\n  background: #f0fdf4 !important;\n  color: #101828 !important;\n  font-size: 12px;\n  font-weight: 500;\n  border-bottom: 1px solid #bbf7d0 !important;\n}\n\n.approve-offer-table .ant-table-tbody > tr.ant-table-row:hover > td {\n  background: #f0fdf4 !important;\n}\n\n.approve-offer-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none !important;\n}\n\n.approve-offer-percentage {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.approve-offer-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.bulk-campaign-modal-content {\n  width: 100%;\n}\n.bulk-campaign-form .ant-form-item {\n  margin-bottom: 16px;\n}\n.bulk-campaign-form .ant-form-item-label {\n  padding-bottom: 6px;\n}\n.bulk-campaign-radio-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.bulk-campaign-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.bulk-campaign-modal-actions .ant-btn {\n  min-width: 120px;\n}\n.bulk-campaign-modal-actions .common-button-red {\n  min-width: 180px;\n}\n.bulk-campaign-date-picker.ant-picker-outlined {\n  background: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  border-color: #d9d9d9 !important;\n}\n/* Inactive option text */\n.bulk-campaign-radio-group .ant-radio-wrapper {\n  color: #99a1af;\n}\n\n/* Selected option text */\n.bulk-campaign-radio-group .ant-radio-wrapper-checked {\n  color: #000000;\n}\n.select-campaign-dropdown .ant-select-selector {\n  padding: 0px !important;\n}\n.cancel-create-campaign-btn {\n  height: 35px !important;\n  border-radius: 5px !important;\n  background: #f3f4f6 !important;\n  border-color: #d9d9d9 !important;\n  color: #000000 !important;\n  font-family: Roboto !important;\n  font-weight: 500;\n}\n@media (max-width: 576px) {\n  .bulk-campaign-form > div:first-child {\n    grid-template-columns: minmax(0, 1fr) !important;\n    gap: 0 !important;\n  }\n\n  .bulk-campaign-radio-group {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .bulk-campaign-modal-actions {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
